const globalLogCenter = {
    path: "globalLogCenter",
    name: "globalLogCenter",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'systemAuditLog',
        icon: 'HSIconfont hs-icon-file',
        showRealm: ['GLOBAL']
    },
    children: [
        {
            path: 'globalLoginLog',
            name: 'globalLoginLog',
            component: () => import('@/views/globalLoginLog/index.vue'),
            meta: { code: 'systemAuditLog:authLog' }
        },
        {
            path: 'globalBusinessLog',
            name: 'globalBusinessLog',
            component: () => import('@/views/globalBusinessLog/index.vue'),
            meta: { code: 'systemAuditLog:businessLog' }
        }
    ]
};
export default globalLogCenter;
